const setEditMode = (state, payload) => {
  state.isPPTEditMode = payload
}
const setActiveViewMode = (state, payload) => {
  state.addinPPTActiveView = payload
  if (payload) state.isPptActiveViewConfirmed = true
}
const setPptSlideLostFocus = (state, payload) => {
  state.pptSlideLostFocus = payload
}
export default {
  setEditMode,
  setActiveViewMode,
  setPptSlideLostFocus,
}
